import action from './action'

export default {
    getPhone(params) {
        return action.request('get_welcom_product',{query: JSON.stringify(params)})
    },
    getInsurances() {
        return action.request('get_welcom_insurances')
    },
    saveEstimate(data) {
        return action.request('save_estimate',{element: JSON.stringify(data)})
    }
}
